import { TranslateService } from '@ngx-translate/core';

const FIELD_ERROR_SUFFIXES: Record<string, string> = {
  'must be a number.': 'mustBeNumber',
  'must be true or false.': 'mustBeBoolean',
  'must be a valid date.': 'mustBeDate',
  'must be a JSON array of objects.': 'mustBeObjectArray',
  'must be a JSON object.': 'mustBeJsonObject',
  'must be an object.': 'mustBeObject',
  'is not part of the schema.': 'notInSchema',
  'is required.': 'required',
  'must be a valid email address.': 'mustBeEmail',
  'must use lowercase characters.': 'mustBeLowercase',
  'is shorter than the allowed minimum.': 'tooShort',
  'is longer than the allowed maximum.': 'tooLong',
  'has an invalid format.': 'invalidFormat',
  'has an invalid schema regex.': 'invalidRegex',
  'must be one of the allowed values.': 'notAllowed',
  'is below the allowed minimum.': 'belowMinimum',
  'is above the allowed maximum.': 'aboveMaximum',
  'must be a whole number.': 'mustBeInteger',
  'must be a date (YYYY-MM-DD) to validate its date range.': 'mustBeRangeDate',
  'has an invalid minDaysAgo rule.': 'invalidRecentDateRule',
  'has an unsupported min date bound; use YYYY-MM-DD.': 'unsupportedMinDateBound',
  'has an unsupported max date bound; use YYYY-MM-DD.': 'unsupportedMaxDateBound',
  'is before the earliest allowed date.': 'beforeEarliestDate',
  'is after the latest allowed date.': 'afterLatestDate'
};

const FILE_ERROR_KEYS: Record<string, string> = {
  'No data header row was found.': 'noHeaderRow',
  'The data header row is empty.': 'emptyHeaderRow',
  'The workbook has no sheets.': 'emptyWorkbook'
};

export function localizeTridyImportError(error: string, translate: TranslateService): string {
  const fileKey = FILE_ERROR_KEYS[error];
  if (fileKey) return translate.instant(`tridys.importWizard.errors.${fileKey}`);

  const arrayLength = error.match(/^(.*?) must contain at (least|most) (\d+) items\.$/);
  if (arrayLength) {
    return translate.instant(`tridys.importWizard.errors.${arrayLength[2] === 'least' ? 'arrayTooShort' : 'arrayTooLong'}`, {
      field: arrayLength[1], count: arrayLength[3]
    });
  }

  const multipleOf = error.match(/^(.*?) must be a multiple of (.+)\.$/);
  if (multipleOf) {
    return translate.instant('tridys.importWizard.errors.mustBeMultipleOf', {
      field: multipleOf[1], value: multipleOf[2]
    });
  }

  const patterns: Array<[RegExp, string, string]> = [
    [/^(.*?) uses unsupported validation rule "(.*?)"; this import cannot validate it\.$/, 'unsupportedRule', 'rule'],
    [/^(.*?) uses unsupported text format "(.*?)"; this import cannot validate it\.$/, 'unsupportedTextFormat', 'format'],
    [/^(.*?) has an invalid (.*?) format\.$/, 'invalidNamedFormat', 'format'],
    [/^(.*?) must be within the last (.*?) days\.$/, 'outsideRecentDays', 'days']
  ];
  for (const [pattern, key, parameter] of patterns) {
    const match = error.match(pattern);
    if (match) return translate.instant(`tridys.importWizard.errors.${key}`, { field: match[1], [parameter]: match[2] });
  }

  for (const [suffix, key] of Object.entries(FIELD_ERROR_SUFFIXES)) {
    if (error.endsWith(` ${suffix}`)) {
      return translate.instant(`tridys.importWizard.errors.${key}`, {
        field: error.slice(0, -(suffix.length + 1))
      });
    }
  }

  return error;
}
